export const ColoresBlu = Object.freeze({
  BLU_1: '#0420BF',
  BLU_2: '#1374F2',
  BLU_3: '#5C9DF2'
})
export const DIAS_FACTORAJE = 45
export const GEN_RFC = 'XEXX010101000' // Extranjero
// #0420BF
// #5C9DF2
// #1374F2
// #B5B5B5
// #1F64D5
